module.exports = __webpack_public_path__ + "img/hookahking.53c1a25d.jpg";